import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyList: [],
  selectedCompany: null,
  selectedCompanyId: null,
};

const companySlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    companyListAction: (state, action) => {
      state.companyList = [...state.companyList];
    },
    companySelectAction: (state, action) => {
      state.selectedCompany = action.payload.selectedCompany;
      state.selectedCompanyId = action.payload.selectedCompanyId;
      localStorage.setItem('CompanyId',action.payload.selectedCompanyId);
    },
    resetStateCompanyAction: (state) => {
      state.companyList = [];
      state.selectedCompany = null;
      state.selectedCompanyId = null;
      localStorage.removeItem("CompanyId");
    },
  },
});

export const {
  companyListAction,
  companySelectAction,
  resetStateCompanyAction
} = companySlice.actions;

export default companySlice.reducer;
